import '../styles/PartnersMarquee.css';

// Swap each `img` for the real logo file once you save it to
// public/images/partners/ — filenames noted per item below.
const PARTNERS = [
  { name: 'X', img: '/images/partners/x.png' },
  { name: 'Solana', img: '/images/partners/solana.png' },
  { name: 'TradingView', img: '/images/partners/tradingview.png' },
  { name: 'Business Insider', img: '/images/partners/business-insider.png' },
  { name: 'TikTok', img: '/images/partners/tiktok.png' },
];

export default function PartnersMarquee() {
  // Duplicate the list so the CSS animation can loop seamlessly (scroll
  // exactly -50%, then jump back unnoticed since the second half is
  // identical to the first).
  const track = [...PARTNERS, ...PARTNERS];

  return (
    <div className="partners-marquee" role="presentation">
      <div className="partners-marquee__track">
        {track.map((partner, i) => (
          <span className="partners-marquee__item" key={`${partner.name}-${i}`}>
            <img
              src={partner.img}
              alt={partner.name}
              onError={(e) => {
                // Fallback to plain text if the logo file isn't saved yet.
                e.currentTarget.style.display = 'none';
                e.currentTarget.nextSibling.style.display = 'inline';
              }}
            />
            <span className="partners-marquee__fallback">{partner.name}</span>
          </span>
        ))}
      </div>
    </div>
  );
}